import { render, staticRenderFns } from "./extraFieldsGold.vue?vue&type=template&id=410426be"
import script from "./extraFieldsGold.vue?vue&type=script&lang=js"
export * from "./extraFieldsGold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports